import { MatrixTableNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";
import { predicateToSearchableField } from "src/flowGraph/canvasSearch/nodesExtractors/decisionTableExtractors";

export const extractMatrixTableFields = (
  data: MatrixTableNodeData,
): SearchableField[] => {
  const columnPredicates = data.column_predicates.map(
    predicateToSearchableField,
  );
  const rowPredicates = data.row_predicates.map(predicateToSearchableField);
  return [
    data.row_field,
    data.column_field,
    data.result_field,
    ...columnPredicates,
    ...rowPredicates,
    ...data.grid_effects.flat(),
    data.fallback,
  ];
};
